import { Observable } from 'rxjs';
import { fetchProjectImageListAPI } from '../../api/fetch-functions/project-image';
import { IProjectImageInfoType } from '../../types/record/image-info';
import { ListWithPromiseState } from './common/list-with-status';
import {
  fetchIdStreamGenerator,
  fetchListFnGenerator,
  listOfIdFnGenerator,
  oneIdListSetReducerGenerator,
  oneIdListSetStreamGenerator,
  updateStreamGenerator
} from './common/one-id-list';

const fetchSignal$ = fetchIdStreamGenerator();

// 仮引数のリネームのためいったん変数`f`に格納
const f = fetchListFnGenerator(fetchSignal$);
export const fetchProjectImageListOf = (projectId: number) => f(projectId);

/**
 * @description
 * `fetchProjectImageListOf(projectId)` を実行すると
 * `projectImageListSet$` の該当idの要素を re-fetch する．
 */
const updateProjectImageList$ = updateStreamGenerator(
  fetchSignal$,
  fetchProjectImageListAPI
);

const projectImageListSetReducer = oneIdListSetReducerGenerator<
  IProjectImageInfoType
>();

/**
 * @description
 * すべての projectImageList の集合．必要になったものからfetchして蓄える．
 * 複数のcomponentで共有するため．
 */
const projectImageListSet$ = oneIdListSetStreamGenerator(
  updateProjectImageList$,
  projectImageListSetReducer
);

const g = listOfIdFnGenerator(projectImageListSet$);
export const projectImageListOf = (
  projectId: number
): Observable<ListWithPromiseState<IProjectImageInfoType>> => {
  fetchProjectImageListOf(projectId);
  return g(projectId);
};
